/* Componente per l' aggiunta del layer filtrato  */

import { useLeaflet } from "react-leaflet";
import { useEffect } from "react";
import { connect } from "react-redux";
import * as WMS from "leaflet.wms";


//Aggiunta Layer
const addLayer = (map,query) => {
    
    var cql_query = ""
    switch (query.operator.type) {
        case "Geometric":
            cql_query = `${query.operator.name}(${query.field.fieldName}, ${query.value})`
            break;
        case "Compare":
            cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name} '${query.value}'`
            break;
        case "Function":
            let value = ""
            switch (query.operator.name) {
                case "IN":
                    value = `(${query.value})`
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name} ${value}`
                    break;
                case "IS NULL":
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name}`
                    break;
                case "IS NOT NULL":
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name}`
                    break;
                case "BETWEEN":
                    
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name} ${query.value}`
                    break;
                case "NOT BETWEEN":
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name} ${query.value}`
                    break;
                default:
                    value = `'${query.value}'`
                    cql_query = `strToLowerCase(${query.field.fieldName}) ${query.operator.name} ${value}`
                    break;
            }
            
            break;
        default:
            break;
    }
    
    const options = {
        "format": "image/png",
        "transparent": "true", 
        "info_format": "application/json",
        "cql_filter": cql_query
        
    }
    
    // Add WMS source/layers
    const source = WMS.source(
        query.layer.serviceUrl,
        options
    );
     source.getLayer(query.layer.name).addTo(map)    
}


//Rimozione Layer
const removeLayer = (map,query) => { 
    map.eachLayer(element => {
        if ( element._name === query.layer.name) {
            try { 
                map.removeLayer(element)
            }
            catch(e) {
            }
        }
    }); 
}

//Componente aggiunta layer filtrato
function Query (props) {
    const { map } = useLeaflet();
    
    const actionLayer = (query) => {
        if (query.action === true){
            removeLayer(map,query)
            addLayer(map,query)
        }else if (query.action === false){
            removeLayer(map,query)
        }
         
    }


    useEffect(()=>{
            actionLayer(props.query)

    },[props.query])


    return null;
};


const mapStateToProps = state => {
    return {
        query: state.query.query
    }
  }

export default connect(mapStateToProps) (Query);